const STYLES = {
    GREEN: "#31BD9C",
    BLUE: "#307CF5",
    GRAY:"#747474",
    BLACK:"#000000",
    BACKGROUND:"#F2F1F1"
};

export default STYLES;
